<template>
  <button class="ui button disabled" v-if="shopRank === 'D'"><i class="heart icon"></i>一括問合せ対象外</button>
  <button class="ui button checked" v-else-if="checked && shopRank !== 'D'" @click.prevent="toggle"><i class="heart icon"></i>リストに追加済み</button>
  <button class="ui button" v-else-if="!checked && shopRank !== 'D'"  @click.prevent="toggle"><i class="heart outline icon"></i>一括問合せリストに追加</button>
</template>

<script>

export default {
    data: function() {
        return {
            checked: false
        };
    },
    props: {
        shopId: {
            require: true,
            type: Number
        },
        shopRank: {
            require: true,
            type: String,
        }
    },
    created: function() {
        this.syncCheckedState();
    },
    methods: {
        toggle: function() {
            var shops = this.selectedShops();
            if (!this.checked && shops.length >= 10) {
                alert('まとめて問い合わせリストに追加できるのは10件までです');
                return;
            }
            this.checked = !this.checked;
            _.remove(shops, function(shopId) {
                return this.shopId === shopId;
            }.bind(this));
            if (this.checked) {
                shops.push(this.shopId);
            }
            this.setShops(shops);
            this.$root.selectedShopCount = shops.length;
        },
        syncCheckedState() {
            this.checked = _.includes(this.selectedShops(), this.shopId);
        }
    },
    watch: {
      '$root.selectedShopCount': function() {
        this.syncCheckedState();
      }
    },
};
</script>
